import { createMiddleware } from '@shared/redux';
import {
    changeOptions,
    disableClearRules,
    enableClearRules,
    enableOpenSaveModal,
    ON_CHANGE_FIELD,
} from './interface.state';
import {
    SET_UNNAMED_FILTER,
} from '../filters/filters.state';
import { SET_CUSTOM_FILTER_RULES } from '../rules/rules.state';
import { AVAILABLE_FIELDS } from '../campaigns-filter.constants';
import { enumToSelectOptions } from './interface.utils';

export const interfaceMiddlewares = createMiddleware({
    [SET_UNNAMED_FILTER]: enableOpenSaveModal,
    [SET_CUSTOM_FILTER_RULES]: (_, action) => {
        const rules = action.payload;
        if (rules.length > 0) {
            return enableClearRules();
        }
        return disableClearRules();
    },
    [ON_CHANGE_FIELD]: (_, action) => {
        const operatorOptions = getOperationOptionsByField(action.payload.value);

        return changeOptions({ operatorOptions: enumToSelectOptions(operatorOptions) });
    },
});

const getOperationOptionsByField = field => Object.values(AVAILABLE_FIELDS)
    .find(filter => filter.name === field).operations;
